import axios from 'axios';

export default function completeChangeorder(siteId, orderNumber) {
  const url = `${window.location.origin}/api/ordering/completechangeorder?siteId=${siteId}&orderNumber=${orderNumber}`;

  return axios.put(url);
}
